import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertType, AlertTypeCreateRequest } from '@models/index';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AlertTypesService {
  private readonly url = `${environment.bffUrl}/monitoring/alert-types`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<AlertType[]> {
    return this.http.get<AlertType[]>(this.url);
  }

  add(dto: AlertTypeCreateRequest): Observable<AlertType> {
    return this.http.post<AlertType>(this.url, dto);
  }
}
